<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import SectorsPanel from 'dashboard/components-next/Products/SectorsPanel.vue';
import ProductsPanel from 'dashboard/components-next/Products/ProductsPanel.vue';
import ProductPlansPanel from 'dashboard/components-next/Products/ProductPlansPanel.vue';
import AddOnsPanel from 'dashboard/components-next/Products/AddOnsPanel.vue';

const { t } = useI18n();
const sectorsPanelRef = ref(null);
const selectedSector = ref(null);
const selectedProduct = ref(null);

const onSelectSector = sector => {
  selectedSector.value = selectedSector.value?.id === sector.id ? null : sector;
  selectedProduct.value = null;
};

const onSelectProduct = product => {
  selectedProduct.value = product;
};
</script>

<template>
  <div class="flex flex-col w-full h-full gap-4 p-6 overflow-y-auto">
    <div class="flex flex-col gap-1">
      <h1 class="text-xl font-medium text-n-slate-12">
        {{ t('PRODUCTS_MGMT.PAGE_TITLE') }}
      </h1>
      <p class="text-sm text-n-slate-11">
        {{ t('PRODUCTS_MGMT.PAGE_DESCRIPTION') }}
      </p>
    </div>

    <SectorsPanel ref="sectorsPanelRef" @select-sector="onSelectSector" />

    <ProductsPanel
      :sectors="sectorsPanelRef?.sectors || []"
      :selected-sector="selectedSector"
      @select-product="onSelectProduct"
    />

    <template v-if="selectedProduct">
      <ProductPlansPanel :product="selectedProduct" />
      <AddOnsPanel :product="selectedProduct" />
    </template>
  </div>
</template>
